import React from 'react';
import { AppStateProvider } from './DataProviders/AppStateProvider';
import AppContentRouter from './Components/AppContentRouter';

/**
 * Provide a global context with state management to our application
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export const AfeQuickCheckApp = props => {
  return (
    <AppStateProvider>
      <AppContentRouter />
    </AppStateProvider>
  );
}
